import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/eyebrows1.jpg"

const description = (
  <div>
    <p>EYEBROW AND EYELASH TREATMENT</p>
    <p>
      Perfect all year round, you can give brows the perfect colour and
      beautifully defined shape. This treatment is designed to darken and
      enhance lashes and brows making them look thicker and longer.
    </p>
  </div>
)

const Eyebrows = () => (
  <Layout>
    <SEO title="Eyebrows and eyelash treatments" />
    <Treatment
      image={image}
      title="Eyebrows and eyelash treatments"
      htmlText={description}
    />
  </Layout>
)

export default Eyebrows
